import React, { useState, useEffect } from 'react';
import { subscribeToChannels, createDefaultChannel } from '../services/channelService';
import CreateChannelForm from './CreateChannelForm';
import './ChannelList.css';

const ChannelList = ({ currentUser, selectedChannel, onChannelSelect }) => {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showCreateForm, setShowCreateForm] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError('');

    const unsubscribe = subscribeToChannels(async (channelsData) => {
      // If no channels exist, create the default channel
      if (channelsData.length === 0) {
        try {
          const defaultChannel = await createDefaultChannel();
          setChannels([defaultChannel]);
          // Auto-select the default channel if no channel is selected
          if (!selectedChannel) {
            onChannelSelect(defaultChannel);
          }
        } catch (error) {
          setError('Failed to create default channel');
          console.error('Error creating default channel:', error);
        }
      } else {
        setChannels(channelsData);
        // Auto-select the first channel if no channel is selected
        if (!selectedChannel && channelsData.length > 0) {
          onChannelSelect(channelsData[0]);
        }
      }
      setLoading(false);
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [selectedChannel, onChannelSelect]);

  const handleChannelCreated = () => {
    setShowCreateForm(false);
  };

  if (loading) {
    return (
      <div className="channel-list-container">
        <div className="channel-list-header">
          <h3>Channels</h3>
        </div>
        <div className="loading-channels">
          <div className="loading-spinner-small"></div>
          <p>Loading channels...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="channel-list-container">
        <div className="channel-list-header">
          <h3>Channels</h3>
        </div>
        <div className="channel-error-message">
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="channel-list-container">
      <div className="channel-list-header">
        <h3>Channels</h3>
        <button 
          className="create-channel-button"
          onClick={() => setShowCreateForm(true)}
          title="Create new channel"
        >
          +
        </button>
      </div>

      {showCreateForm && (
        <CreateChannelForm 
          currentUser={currentUser}
          onChannelCreated={handleChannelCreated}
          onCancel={() => setShowCreateForm(false)}
        />
      )}

      <div className="channels-list">
        {channels.map((channel) => (
          <div 
            key={channel.id} 
            className={`channel-item ${selectedChannel?.id === channel.id ? 'selected' : ''}`}
            onClick={() => onChannelSelect(channel)}
          >
            <div className="channel-info">
              <div className="channel-name">
                <span className="channel-hash">#</span>
                {channel.name}
                {channel.isDefault && <span className="default-badge">default</span>}
              </div>
              {channel.description && (
                <div className="channel-description">{channel.description}</div>
              )}
            </div>
            <div className="channel-meta">
              <span className="channel-posts-count">{channel.postsCount || 0}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChannelList;